import { render, staticRenderFns } from "./posCategoryIndex.vue?vue&type=template&id=0f1b421b&"
import script from "./posCategoryIndex.vue?vue&type=script&lang=js&"
export * from "./posCategoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports